// areas
export const PARTS_AREAS = [
  "Двигун і система живлення",
  "Охолодження",
  "Змащення (масляна система)",
  "Випускна система",
  "Трансмісія",
  "Підвіска / Ходова",
  "Гальмівна система",
  "Рульове керування",
  "Електрика / Електроніка",
  "Кузов та зовнішні елементи",
  "Салон і внутрішні елементи",
  "Шини та диски",
  "Освітлення",
  "Електроніка та гаджети",
  "Комфорт і інтерʼєр (аксесуари)",
  "Екстерʼєр (аксесуари)",
  "Догляд та захист",
  "Інструменти та додаткове обладнання",
  "Інше",
];

// sections by area
const SECTIONS_BY_AREA = {
  "Двигун і система живлення": [
    "Двигун у зборі",
    "Блок / ГБЦ / Поршнева",
    "ГРМ та клапани",
    "Паливна система",
    "Наддув (турбіна / інтеркулер)",
    "Прокладки / Сальники",
  ],
  "Охолодження": [
    "Радіатор / Вентилятор",
    "Термостат / Помпа",
    "Бачок розширювальний / Патрубки",
  ],
  "Змащення (масляна система)": ["Масляний насос", "Фільтр / Піддон / Щуп"],
  "Випускна система": [
    "Глушник / Резонатор",
    "Каталізатор / DPF",
    "Лямбда-зонд",
    "Труби / Кріплення",
  ],
  "Трансмісія": [
    "Коробка передач (МКПП/АКПП/DSG/CVT)",
    "Зчеплення",
    "Кардан / Півосі / ШРУС",
    "Редуктор",
  ],
  "Підвіска / Ходова": [
    "Амортизатори / Пружини",
    "Важелі / Сайлентблоки",
    "Стабілізатори / Стійки",
    "Кульові опори",
  ],
  "Гальмівна система": [
    "Диски / Барабани",
    "Колодки",
    "Супорти / Циліндри",
    "Вакуумний підсилювач",
    "ABS / Датчики",
  ],
  "Рульове керування": [
    "Рейка рульова",
    "Тяги / Наконечники",
    "ГУР / ЕУР",
    "Карданчик рульовий",
  ],
  "Електрика / Електроніка": [
    "Акумулятор",
    "Генератор / Стартер",
    "Датчики (ABS/темп/тиск/лямбда тощо)",
    "ECU / Блоки керування",
    "Проводка / Реле / Запобіжники",
  ],
  "Кузов та зовнішні елементи": [
    "Крила / Капот / Двері / Багажник",
    "Бампери / Решітка",
    "Дзеркала",
    "Скло (лобове/бічне/заднє)",
  ],
  "Салон і внутрішні елементи": [
    "Сидіння / Підголівники",
    "Кермо",
    "Панель приладів / Консоль",
    "Обшивки дверей / Підлокітники / Ремені",
    "Пічка / Кондиціонер (вузли)",
  ],
  "Шини та диски": [
    "Шини",
    "Диски",
    "Комплекти (шини+диски)",
    "Болти / Гайки / Проставки",
    "Ковпаки",
  ],
  "Освітлення": [
    "Лампи (LED / Ксенон)",
    "Фари / ПТФ / Додаткове світло",
    "Підсвітка салону",
  ],
  "Електроніка та гаджети": [
    "Відеореєстратори",
    "Парктроніки / Камери",
    "GPS-навігатори",
    "Зарядні / Інвертори",
    "Сигналізація / Іммобілайзер",
  ],
  "Комфорт і інтерʼєр (аксесуари)": [
    "Чохли / Підголівники",
    "Килимки",
    "Органайзери / Багажник",
    "Сонцезахисні шторки",
    "Підлокітники / Підстаканники",
    "Ароматизатори",
  ],
  "Екстерʼєр (аксесуари)": [
    "Дефлектори (вікна/капот)",
    "Накладки / Молдинги / Пороги",
    "Багажники на дах / Бокси",
    "Бризковики",
    "Ковпаки",
  ],
  "Догляд та захист": [
    "Автохімія (шампуні/поліролі/воски/скло)",
    "Чохол-накидка на авто",
    "Антибуксувальні килимки",
    "Захисні плівки",
  ],
  "Інструменти та додаткове обладнання": [
    "Домкрат",
    "Насос / Компресор",
    "Набір ключів",
    "Трос буксирувальний",
    "Аптечка / Вогнегасник",
    "Знак аварійної зупинки",
  ],
  "Інше": ["Інші авто-товари"],
};

// subcategories
const SUBCATS_BY_SECTION = {
  "Двигун у зборі": [],
  "Блок / ГБЦ / Поршнева": [],
  "ГРМ та клапани": [],
  "Паливна система": ["Насоси", "Форсунки", "Фільтри", "Інше"],
  "Наддув (турбіна / інтеркулер)": [],
  "Прокладки / Сальники": [],

  "Радіатор / Вентилятор": [],
  "Термостат / Помпа": [],
  "Бачок розширювальний / Патрубки": [],

  "Масляний насос": [],
  "Фільтр / Піддон / Щуп": [],

  "Глушник / Резонатор": [],
  "Каталізатор / DPF": [],
  "Лямбда-зонд": [],
  "Труби / Кріплення": [],

  "Коробка передач (МКПП/АКПП/DSG/CVT)": [],
  "Зчеплення": ["Диск", "Корзина", "Вижимний підшипник"],
  "Кардан / Півосі / ШРУС": [],
  "Редуктор": [],

  "Амортизатори / Пружини": [],
  "Важелі / Сайлентблоки": [],
  "Стабілізатори / Стійки": [],
  "Кульові опори": [],

  "Диски / Барабани": [],
  "Колодки": [],
  "Супорти / Циліндри": [],
  "Вакуумний підсилювач": [],
  "ABS / Датчики": [],

  "Рейка рульова": [],
  "Тяги / Наконечники": [],
  "ГУР / ЕУР": [],
  "Карданчик рульовий": [],

  "Акумулятор": [],
  "Генератор / Стартер": [],
  "Датчики (ABS/темп/тиск/лямбда тощо)": [],
  "ECU / Блоки керування": [],
  "Проводка / Реле / Запобіжники": [],

  "Крила / Капот / Двері / Багажник": [],
  "Бампери / Решітка": [],
  "Дзеркала": [],
  "Скло (лобове/бічне/заднє)": [],

  "Сидіння / Підголівники": [],
  "Кермо": [],
  "Панель приладів / Консоль": [],
  "Обшивки дверей / Підлокітники / Ремені": [],
  "Пічка / Кондиціонер (вузли)": [],

  "Шини": [],
  "Диски": [],
  "Комплекти (шини+диски)": [],
  "Болти / Гайки / Проставки": [],
  "Ковпаки": [],

  "Лампи (LED / Ксенон)": [],
  "Фари / ПТФ / Додаткове світло": [],
  "Підсвітка салону": [],

  "Відеореєстратори": [],
  "Парктроніки / Камери": [],
  "GPS-навігатори": [],
  "Зарядні / Інвертори": [],
  "Сигналізація / Іммобілайзер": [],

  "Чохли / Підголівники": [],
  "Килимки": [],
  "Органайзери / Багажник": [],
  "Сонцезахисні шторки": [],
  "Підлокітники / Підстаканники": [],
  "Ароматизатори": [],

  "Дефлектори (вікна/капот)": [],
  "Накладки / Молдинги / Пороги": [],
  "Багажники на дах / Бокси": [],
  "Бризковики": [],
  "Ковпаки": [],

  "Автохімія (шампуні/поліролі/воски/скло)": [],
  "Чохол-накидка на авто": [],
  "Антибуксувальні килимки": [],
  "Захисні плівки": [],

  "Домкрат": [],
  "Насос / Компресор": [],
  "Набір ключів": [],
  "Трос буксирувальний": [],
  "Аптечка / Вогнегасник": [],
  "Знак аварійної зупинки": [],

  "Інші авто-товари": [],
};

// fields
export const partsFields = (attrs) => {
  const a = attrs || {};
  const area = a.area || "";
  const section = a.section || "";

  const areaOnly = [
    {
      name: "area",
      label: "Система / Розділ *",
      type: "select",
      options: PARTS_AREAS,
      required: true,
    },
  ];
  if (!area) return areaOnly;

  const sectionOnly = [
    ...areaOnly,
    {
      name: "section",
      label: "Підрозділ",
      type: "select",
      options: SECTIONS_BY_AREA[area] || [],
      required: false,
    },
  ];
  if (!section) return sectionOnly;

  // wheels extras
  const extra = [];

  if (area === "Шини та диски" && (section === "Шини" || section === "Комплекти (шини+диски)")) {
    extra.push({
      name: "tireSize",
      label: "Розмір шин",
      type: "text",
      placeholder: "Напр.: 255/55 R16 або 255/55/16",
      showIf: (s) =>
        s.area === "Шини та диски" &&
        (s.section === "Шини" || s.section === "Комплекти (шини+диски)"),
    });
  }

  if (area === "Шини та диски" && (section === "Диски" || section === "Комплекти (шини+диски)")) {
    extra.push({
      name: "boltPattern",
      label: "Розболтовка (PCD)",
      type: "text",
      placeholder: "Напр.: 5x114.3",
      showIf: (s) =>
        s.area === "Шини та диски" &&
        (s.section === "Диски" || s.section === "Комплекти (шини+диски)"),
    });
  }

  const subcats = SUBCATS_BY_SECTION[section] || [];
  if (!subcats.length) return [...sectionOnly, ...extra];

  return [
    ...sectionOnly,
    ...extra,
    {
      name: "subcategory",
      label: "Підкатегорія",
      type: "select",
      options: subcats,
      required: false,
    },
  ];
};
